<template>
    <form :class="{'form-dark': dark}" @submit.prevent="login">
        <div class="form-group" :class="{'has-danger': invalidLogin}">
            <label v-if="label" :for="`username_${_uid}`">
                <i class="fa fa-fw fa-user" aria-hidden="true"></i>
                {{ $t('login_username') }}:
            </label>
            <input v-model="formData.username" type="text" class="form-control"
                   :id="`username_${_uid}`"
                   :placeholder="$t('login_username')"
                   :class="{'form-control-danger': invalidLogin}">
        </div>
        <div class="form-group" :class="{'has-danger': invalidLogin}">
            <label v-if="label" :for="`password_${_uid}`">
                <i class="fa fa-fw fa-key" aria-hidden="true"></i>
                {{ $t('login_password') }}:
            </label>
            <input v-model="formData.password" type="password" class="form-control"
                   :id="`password_${_uid}`"
                   :placeholder="$t('login_password')"
                   :class="{'form-control-danger': invalidLogin}">
        </div>
        <button class="btn btn-primary pull-right" type="submit">
            <i class="fa fa-sign-in-alt" aria-hidden="true"></i>
            {{ $t('login_login') }}
        </button>
        <button v-if="reset" class="btn btn-outline-secondary pull-right mr-3" @click.prevent="link('PasswordRecovery')">
            <i class="fa fa-question" aria-hidden="true"></i>
            {{ $t('login_forgotPwd') }}
        </button>
    </form>
</template>

<script>
import { API, setAuthorizationToken } from '../../api/axios'
import { mapGetters } from 'vuex'
import * as qs from 'qs'

export default {
  name: 'LoginComponent',
  props: {
    dark: {
      required: false,
      type: Boolean,
      default: false,
    },
    reset: {
      required: false,
      type: Boolean,
      default: false,
    },
    label: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      formData: {
        username: window.configECP.testUsername,
        password: window.configECP.testPassword,
      },
      invalidLogin: false,
    }
  },
  computed: {
    ...mapGetters(['language', 'reservation']),
  },
  methods: {
    link (to) {
      this.$router.push({name: to, params: {lang: this.language}})
    },
    login () {
      this.invalidLogin = false
      let login = {...this.formData}

      // Add reservation id to login if present
      if (this.reservation) {
        login.transactionId = this.reservation.id
      }

      API.post(`/users/login?${qs.stringify(login)}`)
        .then(response => {
          if (response.data === null) {
            return Promise.reject(new Error('Response was null!'))
          } else {
            this.invalidLogin = false
            setAuthorizationToken(response.data.token)
            this.$store.commit('changeUserData', response.data)
            let current = {
              name: this.$route.name,
              params: this.$route.params,
              query: this.$route.query,
            }
            current.params.lang = this.language

            this.$router.replace(current)
            this.$emit('loggedIn')
          }
        })
        .catch(error => {
          this.invalidLogin = true
          // Vibrate device if invalid
          navigator.vibrate(250)
          console.error('Authentication failed!', error)
        })
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utilities/LoginComponent.vue